// extracted by mini-css-extract-plugin
export default {"container":"Options_container__OiJjJ","header":"Options_header__13b3k","wrapper":"Options_wrapper__7BwEW"};